import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { LzTFunctionSimple } from '@lz-types/types';

export interface LzPPrint {
    heading?: string;
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    onReload?: LzTFunctionSimple;
    showBottomRightPaging?: boolean;
    printInLandscape?: boolean;
    /**
     * @var autoPrintOnceWhen
     * Set this to true if you want to call print dialog automatically immediately.
     * Set it to a condition (like record loaded) to call print dialog automatically once when record is loaded.
     */
    autoPrintOnceWhen?: boolean;
}

export default function LzXPrint(props: LzPPrint) {
    const [autoPrintCalled, setAutoPrintCalled] = useState(false);

    useEffect(() => {
        if (props.autoPrintOnceWhen && !autoPrintCalled) {
            setAutoPrintCalled(true);
            window.print();
        }
    }, [props.autoPrintOnceWhen]);

    return (
        <Paper elevation={0} className={'lz-hide-bg-on-print ' + (props.className || '')}>
            {props.showBottomRightPaging &&
                <style>
                    {
                        `@media print {
                            body {
                                counter-reset: page 1;
                            }

                            @page {
                                counter-increment: page;
                                padding-bottom: 24px;

                                @bottom-right {
                                    content: "Page: " counter(page) " of " counter(pages);
                                    margin-top: -32px;
                                    margin-right: 32px;
                                    font-size: 12px;
                                    font-family: var(--primary-font);
                                }
                            }
                        }`
                    }
                </style>
            }
            {props.printInLandscape &&
                <style>
                    {
                        `@media print {
                            @page {
                                size: landscape;
                            }
                        }`
                    }
                </style>
            }
            <div className="lz-report-wrapper-outer">
                <div className="lz-hide-on-print">
                    <div style={{ textAlign: 'right', paddingTop: 12, paddingBottom: 12 }}>
                        <Button type="button" color="primary" variant="contained" onClick={() => window.print()} style={{ marginRight: 10 }}>Print</Button>
                        <Button type="button" color="secondary" onClick={props.onReload}>Reload</Button>
                        <Button type="button" color="secondary" onClick={() => window.close()}>Close</Button>
                    </div>
                </div>

                <div className="lz-report-wrapper">
                    <div style={{ height: '98vh', display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif' }}>
                        {props.children}
                    </div>
                </div>
            </div>
        </Paper>
    );
}
